import "react-app-polyfill/ie11";
import { createRoot } from "react-dom/client";
import "core-js";

// provider for api calls
import { QueryClient, QueryClientProvider } from "react-query";

// provider for local contexts
import {
  SampleProvider,
  ParamsProvider,
  UserProvider,
  ReachbackProvider,
  AdminProvider,
} from "./contexts";

//components
import NetworkStatus from "./components/NetworkStatus";

// Bootstrap CSS and JS
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// Routes
import Routes from "./Routes";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
    },
  },
});

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <UserProvider>
    <AdminProvider>
      <ReachbackProvider>
        <QueryClientProvider client={queryClient}>
          <ParamsProvider>
            <SampleProvider>
              <Routes />
              <NetworkStatus />
            </SampleProvider>
          </ParamsProvider>
        </QueryClientProvider>
      </ReachbackProvider>
    </AdminProvider>
  </UserProvider>
);
